export enum AtomicOperation {
  GET = '.read.get',
  LIST = '.read.list',
  CREATE = '.write.create',
  UPDATE = '.write.update',
  DELETE = '.write.delete',
}

export const Operation = {
  ALL: '.',
  READ: '.read',
  GET: '.read.get',
  LIST: '.read.list',
  WRITE: '.write',
  CREATE: '.write.create',
  UPDATE: '.write.update',
  DELETE: '.write.delete',
};
